import { combineReducers } from 'redux'

import dishesReducer from './dishes-reducer'

export default combineReducers({
  dishes: dishesReducer,
})
